import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  muhuratData: null,
  loading: false,
  error: null,
  interestingFacts: null,
  factsLoading: false,
  factsError: null,
};

const muhuratSlice = createSlice({
  name: "muhurat",
  initialState,
  reducers: {
    getMuhuratRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getMuhuratSuccess: (state, action) => {
      state.loading = false;
      state.muhuratData = action.payload;
    },
    getMuhuratFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    getInterestingFactsRequest: (state) => {
      state.factsLoading = true;
      state.factsError = null;
    },
    getInterestingFactsSuccess: (state, action) => {
      state.factsLoading = false;
      state.interestingFacts = action.payload;
    },
    getInterestingFactsFailure: (state, action) => {
      state.factsLoading = false;
      state.factsError = action.payload;
    },
  },
});

export const {
  getMuhuratRequest,
  getMuhuratSuccess,
  getMuhuratFailure,
  getInterestingFactsRequest,
  getInterestingFactsSuccess,
  getInterestingFactsFailure,
} = muhuratSlice.actions;

export default muhuratSlice.reducer;
